<template>
  <div class="tab-container" :class="title ? 'space-between' : 'center'">
    <div class="title" v-if="title">
      <router-link tag="span" v-if="back" :to="back">
        <i class="anyteachicon anyteachicon anyteach-arrow-left" /> 查看更多
      </router-link>
      <h1>{{ title }}</h1>
    </div>
    <div class="tab">
      <div class="wrapper">
        <span class="block" ref="block" />
        <span v-for="item in options" :key="item" class="tab-item" @click="switchTab">{{
          item
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: ["options", "value", "title", "back"],
  mounted() {
    if (this.value) {
      this.switchTab(this.options.indexOf(this.value))
    }
  },
  methods: {
    switchTab(e) {
      const className = "tab-item"
      const active = "active"
      const els = [...document.getElementsByClassName(className)]
      let element, index

      if (Number.isInteger(e)) {
        index = e
        element = els[index]
      } else {
        element = e.target
        index = els.indexOf(element)
      }

      if (this.tab === index) return

      els.forEach(el => el.classList.remove(active))
      const x = index * element.clientWidth
      this.$refs.block.style.transform = `translateX(${x}px)`
      this.$emit("input", this.options[index])
      setTimeout(() => {
        if (element) {
          element.classList.add(active)
        }
      }, 100)
      setTimeout(() => {
        if (this.$refs.content) {
          this.$refs.content.classList.remove("fadeIn")
        }
      }, 500)
    },
  }
}
</script>

<style lang="scss" scoped>
.tab-container {
  display: flex;
  padding: 10px 5%;
  align-items: center;
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  height: 50px;
  background: white;
  z-index: 1;
  h1 {
    font-size: 1rem;
  }
}
.center {
  justify-content: center;
}
.space-between {
  border-bottom: $border;
  justify-content: space-between;
  margin: 0 0 10px 0;
}
.title {
  span {
    font-size: 0.8rem;
    opacity: 0.6;
    display: block;
    transition: all 0.1s;
    &:active {
      color: $blue;
      opacity: 1;
    }
  }
  h1 {
    margin: 0;
  }
}
.tab {
  display: inline-block;
  $height: 30px;
  height: $height;

  .wrapper {
    border-radius: $height;
    background: #e6e6e6;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  span {
    width: 65px;
    height: $height;
  }

  .block {
    border-radius: 50px;
    border: 1px solid #e6e6e6;
    position: absolute;
    background: white;
    top: 0;
    left: 0;
    transition: transform 0.3s;
    box-shadow: 0 0 20px -5px #cacaca;
  }

  .tab-item {
    z-index: 1;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.1s;
    &:active {
      transform: scale(0.9);
    }
  }

  .active {
    font-weight: bold;
    &:active {
      transform: none;
    }
  }
}
</style>